import mapValues from 'lodash/mapValues'

import { R } from '@utils/currency'
import { retirementBudgetTotal, currentBudgetTotal } from '@components/DetailedBudget/totals'

export const submitDetailedBudget = async (formValues, updateBudgetHandler) => {
  const {
    net_monthly_current_income,
    detailed_budget,
    use_current_expense_for_retirement,
    gross_monthly_current_income,
    invest_surplus,
    withdraw_deficit
  } = formValues
  const detailedBudget = mapValues(detailed_budget, (budgetItem) => budgetItem.map((value) => R(value).value))
  const selected = 1

  const simple_budget = use_current_expense_for_retirement
    ? R(currentBudgetTotal(detailed_budget)).value
    : R(retirementBudgetTotal(detailed_budget)).value

  await updateBudgetHandler({
    selected,
    detailed_budget: detailedBudget,
    simple_budget,
    use_current_expense_for_retirement,
    net_monthly_current_income: R(net_monthly_current_income).value,
    monthly_current_budget: R(currentBudgetTotal(detailed_budget)).value,
    gross_monthly_current_income: gross_monthly_current_income && R(gross_monthly_current_income).value,
    invest_surplus,
    withdraw_deficit,
  })
}

export const submitSimpleBudget = async (formValues, detailed_budget, updateBudgetHandler) => {
  const {
    net_monthly_current_income,
    monthly_current_budget,
    use_current_expense_for_retirement,
    gross_monthly_current_income,
    invest_surplus,
    withdraw_deficit
  } = formValues
  const selected = 0

  const simple_budget = use_current_expense_for_retirement
    ? R(monthly_current_budget).value
    : R(formValues.simple_budget).value

  await updateBudgetHandler({
    selected,
    detailed_budget,
    use_current_expense_for_retirement,
    invest_surplus,
    withdraw_deficit,
    simple_budget,
    net_monthly_current_income: R(net_monthly_current_income).value,
    monthly_current_budget: R(monthly_current_budget).value,
    gross_monthly_current_income: R(gross_monthly_current_income).value
  })
}
